// import external dependencies
import 'jquery';
import 'slick-carousel';

// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import aboutUs from './routes/about'

// Import components
import SvgInject from '@iconfu/svg-inject/dist/svg-inject'
import TaraSlider from './components/TaraSlider'
import KnowledgeSlider from './components/KnowledgeSlider';
import PodcastsSlider from './components/PodcastsSlider'
import NewPodcastsSlider from './components/NewPodcastsSlider'
import PartnerPodcastsSlider from './components/PartnerPodcastsSlider'
import FolderSlider from './components/FolderSlider'
import BookSlider from './components/BookSlider'
import NewBookSlider from './components/NewBookSlider'
import BlocSlider from './components/BlocSlider'
import TriptychHeader from './components/TriptychHeader'
import CultureOceanSlider from './components/CultureOceanSlider'
import ToolboxFilter from './components/ToolboxFilter'
import Tarapprendre from './components/Tarapprendre'
import PostTypeFilter from './components/PostTypeFilter'
import StickyNav from './navigation/StickyNav'
import MainNav from './navigation/MainNav'
import MobileNav from './navigation/MobileNav'
import DropdownToggle from './navigation/DropdownToggle'
import LoadMore from './components/LoadMore'
import VideoPlyr from './components/VideoPlyr'
import Audio from './components/Audio'
import AudioPlayer from './components/AudioPlayer'
import Discover from './components/Discover'
import Carousel from './components/Carousel'
import Soundcloud from './components/Soundcloud';
import ToolboxRessources from './components/ToolboxRessources';
import ToolboxToolsAjax from './components/ToolboxToolsAjax';
import ToolboxResourcesAjax from './components/ToolboxResourcesAjax';
import NousSoutenirSlider from './components/NousSoutenirSlider';
import NousSoutenirFeaturesSlider from './components/NousSoutenirFeaturesSlider';
import ResourcesSlider from './components/ResourcesSlider';
import Modals from './components/Modals';
import Search from './components/Search';
import Collapse from './components/Collapse';
import Slideshow from './components/Slideshow';
import VideoIframe from './components/VideoIframe';
import SearchModal from './components/SearchModal';
import Tooltip from './components/Tooltip'
import GlobalModal from './components/GlobalModal'
import SliderWithTwoHalf from './components/SliderWithTwoHalf';
import CaruselCard from './components/CaruselCard';
import MultiCards from './components/MultiCards';
import BlackGallery from './components/BlackGallery';
import ExpSlider from './components/ExpSlider';
import GouvernanceSticky from './components/GouvernanceSticky';
import Team from './components/Team'
import Gtm from './components/Gtm'
import Accordion from './components/Accordion';
import SubscribeForm from './components/SubscribeForm';
import OblongResource from './components/OblongResource';
import Wpcf7 from './components/Wpcf7'
import FooterNewsletter from './components/FooterNewsletter';
import ZoomImage from './components/ZoomImage';
import CarouselSlider from './components/CarouselSlider'
import ContactForm from './components/ContactForm';
import PicturesGallery from './components/PicturesGallery';
import Playlist from './components/Playlist';
import Timeline from './components/Timeline';
import TrustCommander from './components/TrustCommander';
import Newsletter from './components/Newsletter';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(() => routes.loadEvents())

jQuery(() => {
  TaraSlider('.tara-slider');
  KnowledgeSlider('.knowledge__slider');
  PodcastsSlider('.podcasts-slider__inner');
  NewPodcastsSlider('.new-podcasts-slider__inner');
  PartnerPodcastsSlider('.podcast__slider');
  FolderSlider('.folder__slider');
  FolderSlider('.discover__slider');
  CarouselSlider('.carousel-images__slider')
  FolderSlider('.pedago__slider');
  BookSlider('.book__slider__inner');
  ExpSlider('.exp-slider__slider');
  // ToolboxFilter('.toolbox__sidebar__header');
  ToolboxFilter('.toolbox__wrapper');
  NewBookSlider('.books-slider__inner');
  VideoPlyr('.video-plyr');
  Playlist('.playlist.video-plyr__container');
  Audio('.audio');
  Discover('.discover');
  BlocSlider('.bloc__slider');
  NousSoutenirSlider('.js-nous-soutenir-slider');
  NousSoutenirFeaturesSlider('.js-nous-soutenir-features-slider');
  ResourcesSlider('.js-resources-slider');
  Carousel('.carousel');
  AudioPlayer('.audio-player--html');
  Soundcloud('.audio-player--soundcloud');
  ToolboxRessources('.toolbox-widget');
  Discover('.discover')
  Modals();
  Collapse();
  Search();
  SliderWithTwoHalf();
  CaruselCard('.carusel-card-slider');
  MultiCards('.multi-cards-slider');
  BlackGallery('.black-gallery-slider');
  Soundcloud('.audio-player--soundcloud')
  Slideshow('.slideshow__slider')
  VideoIframe('.oblong-content__video')
  SearchModal('.search__container')
  Tooltip()
  GlobalModal('[data-role="global-ajax-trigger"]')
  GouvernanceSticky('.js-sticky')
  Team('.team__wrapper')
  Gtm()
  Accordion()
  SubscribeForm('.contacter-form')
  OblongResource('.oblong-content__download')
  Wpcf7()
  FooterNewsletter()
  ZoomImage()
  PicturesGallery('.pictures-gallery')
  Timeline('.timeline-slider')
  Newsletter()
  BlocSlider('[data-name="BlocHeaderSlider"] .slider');

  SvgInject(document.querySelectorAll('img.injectable'))
  const triptychHeader = new TriptychHeader() // eslint-disable-line
  const cultureOceanSlider = new CultureOceanSlider('.articles-slider') // eslint-disable-line
  const tarapprendre = new Tarapprendre() // eslint-disable-line
  const stickyNav = new StickyNav() // eslint-disable-line
  const mainNav = new MainNav() // eslint-disable-line
  const mobileNav = new MobileNav() // eslint-disable-line
  const dropdownToggle = new DropdownToggle() // eslint-disable-line
  const loadmore = new LoadMore() // eslint-disable-line
  const toolboxToolsAjax = new ToolboxToolsAjax() // eslint-disable-line
  const toolboxResourcesAjax = new ToolboxResourcesAjax() // eslint-disable-line
  const postTypeFilter = new PostTypeFilter() // eslint-disable-line
  const contactForm = new ContactForm() // eslint-disable-line

  const trustCommander = new TrustCommander()
  trustCommander.init()

  // Fix Safari address bar issue
  function updateHeight() {
    // Set --vh variable to the actual viewport height
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  // Update height on page load and resize/orientation change
  window.addEventListener('load', updateHeight);
  window.addEventListener('resize', updateHeight);
  window.addEventListener('orientationchange', updateHeight);
});



// WEBPACK FOOTER //
// ./scripts/main.js